module.exports = __webpack_public_path__ + "static/media/birthday-right.708e6b25.svg";